'use client'

import { useState } from 'react'
import Link from 'next/link'
import { useCategories } from '@/lib/hooks/use-categories'
import { ChevronDown, ChevronUp } from 'lucide-react'

const BEBE_ITEMS = [
  { slug: 'de-0-a-3-meses', label: '0 a 3 meses' },
  { slug: 'de-3-a-6-meses', label: '3 a 6 meses' },
  { slug: 'de-6-a-12-meses', label: '6 a 12 meses' },
]

const NINOS_ITEMS = [
  { slug: 'de-12-a-18-meses', label: '1 año' },
  { slug: 'de-2-a-3-anos', label: '2 años' },
  { slug: 'de-3-a-6-anos', label: '3 a 6 años' },
]

function buildNavItems(
  items: { slug: string; label: string }[],
  categories: { id: string; slug: string }[]
) {
  return items
    .map(item => {
      const cat = categories.find(c => c.slug === item.slug)
      return cat ? { id: cat.id, slug: item.slug, label: item.label } : null
    })
    .filter((x): x is { id: string; slug: string; label: string } => x !== null)
}

export function MobileNavLinks({ onClick }: { onClick?: () => void }) {
  const { categories } = useCategories()

  const grupos = {
    bebes: buildNavItems(BEBE_ITEMS, categories),
    ninos: buildNavItems(NINOS_ITEMS, categories),
  }

  // 🔥 Un solo menú EDADES
  const [openEdades, setOpenEdades] = useState(false)

  const linkBase =
    'block px-4 py-4 text-[17px] font-allround font-medium text-[#7D744F] leading-none transition-colors duration-200 hover:text-kuma-verde'

  const sectionTitle =
    'block px-6 py-3 text-[16px] font-allround font-semibold text-[#7D744F] mt-2'

  const childLink =
    'block px-8 py-2 text-[15px] font-allround font-medium text-[#7D744F] leading-tight hover:text-kuma-verde'

  return (
    <div className='space-y-1'>
      {/* 🔹 VER TODOS LOS MATERIALES */}
      <Link href='/productos' className={linkBase} onClick={onClick}>
        Ver todos los materiales
      </Link>
      {/* ⭐⭐ EDADES (UNIFICADO) */}
      {(grupos.bebes.length > 0 || grupos.ninos.length > 0) && (
        <>
          <button
            className={`${linkBase} w-full flex justify-between items-center`}
            onClick={() => setOpenEdades(prev => !prev)}
          >
            Edades
            {openEdades ? (
              <ChevronUp className='w-5 h-5 text-[#7D744F]' />
            ) : (
              <ChevronDown className='w-5 h-5 text-[#7D744F]' />
            )}
          </button>

          {openEdades && (
            <div className='pl-2 pb-3'>
              {/* 🍼 BEBÉ */}
              {grupos.bebes.length > 0 && (
                <>
                  <div className={sectionTitle}>Bebé</div>
                  {grupos.bebes.map(item => (
                    <Link
                      key={item.id}
                      href={`/categorias/${item.slug}`}
                      className={childLink}
                      onClick={onClick}
                    >
                      {item.label}
                    </Link>
                  ))}
                </>
              )}

              {/* 👶 NIÑOS */}
              {grupos.ninos.length > 0 && (
                <>
                  <div className={sectionTitle}>Niños</div>

                  {grupos.ninos.map(item => (
                    <Link
                      key={item.id}
                      href={`/categorias/${item.slug}`}
                      className={childLink}
                      onClick={onClick}
                    >
                      {item.label}
                    </Link>
                  ))}
                </>
              )}
            </div>
          )}
          <Link
            href='/libros-montessori'
            className={linkBase}
            onClick={onClick}
          >
            Libros
          </Link>

          <Link href='/sets-de-regalo' className={linkBase} onClick={onClick}>
            Sets de regalo
          </Link>
        </>
      )}

      {/* ENLACES FIJOS */}
      <Link href='/catalogo-educadores' className={linkBase} onClick={onClick}>
        Centros educativos
      </Link>

      <Link href='/nosotros' className={linkBase} onClick={onClick}>
        Nosotros
      </Link>

      <Link href='/notas-kuma' className={linkBase} onClick={onClick}>
        Notas KUMA
      </Link>
    </div>
  )
}
